import { render, staticRenderFns } from "./GClassImport.vue?vue&type=template&id=52f3df1c&scoped=true&"
import script from "./GClassImport.vue?vue&type=script&lang=ts&"
export * from "./GClassImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3df1c",
  null
  
)

export default component.exports